export default class AnnotController {
  constructor() {}
  removeAnnot() {
    
  }
}
